import { Modal } from '../../components/Modal.tsx';
import { Button, Loading, ErrorState } from '../../components/ui.tsx';
import { ScreenPreviewStage } from './ScreenPreviewStage.tsx';
import { useScreenManifestPreview } from '../../api/screens.ts';

/** "Preview now" — what THIS screen is showing at this moment. Fetches the live
 * manifest-preview (resolved timeline + overlay) and mounts the real playback engine,
 * overlay included. Refresh re-resolves as of now; an unscheduled screen shows an
 * honest empty state rather than a black idle frame. */
export function ScreenPreviewModal({
  screenId,
  screenName,
  onClose,
}: {
  screenId: string;
  screenName: string;
  onClose: () => void;
}) {
  const preview = useScreenManifestPreview(screenId, true);

  return (
    <Modal
      title={`Preview now · ${screenName}`}
      onClose={onClose}
      size="lg"
      footer={
        <>
          <Button onClick={() => preview.refetch()} disabled={preview.isFetching}>
            {preview.isFetching ? 'Refreshing…' : 'Refresh'}
          </Button>
          <Button variant="primary" onClick={onClose}>
            Close
          </Button>
        </>
      }
    >
      {preview.isLoading ? (
        <Loading />
      ) : preview.isError ? (
        <ErrorState message="Could not load the live preview." onRetry={() => preview.refetch()} />
      ) : (
        <>
          <ScreenPreviewStage manifest={preview.data ?? null} screenName={screenName} />
          <p className="hint mt-2">This is what the screen is showing right now, overlay included.</p>
        </>
      )}
    </Modal>
  );
}
